import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import SidebarSolicitante from '../../Components/Sidebar/Sidebar';
import ChamadoCreateForm from './ChamadoCreateForm';
import '../../theme/solicitante-theme.css';
import '../chamadoCreate.css';

function ChamadoCreatePage({
    descricao,
    setDescricao,
    tipo,
    setTipo,
    setor,
    setSetor,
    codSis,
    setCodSis,
    codEqp,
    setCodEqp,
    listSistemas,
    listaEquipamento,
    tipos,
    nomeUsuario,
    emailAdicional,
    setEmailAdicional,
    nomeAnexo,
    onAnexoChange,
    onSubmit,
    salvando,
    mensagem,
    sucesso,
    sugestaoIA,
    sugestaoIALoading,
    sugestaoIAMensagem,
    chamadosRelacionados,
    onBuscarSugestaoIA,
}) {
    if (sucesso === 'S') {
        return <Redirect to="/Solicitante/home" />;
    }

    return (
        <div className="app-layout">
            <SidebarSolicitante />
            <main className="main-content sol-page">
                <div className="chamado-create-page">
                    <Link to="/Solicitante/home" className="chamado-create-back">
                        <i className="fas fa-arrow-left" /> Voltar para meus chamados
                    </Link>
                    <header className="chamado-create-header">
                        <h1>Abrir novo chamado</h1>
                        <p className="chamado-create-subtitle">Descreva o problema ou a solicitação. Quanto mais detalhes, mais rápido o atendimento.</p>
                    </header>
                    <div className="sol-card chamado-create-card">
                    <ChamadoCreateForm
                        descricao={descricao}
                        setDescricao={setDescricao}
                        tipo={tipo}
                        setTipo={setTipo}
                        setor={setor}
                        setSetor={setSetor}
                        codSis={codSis}
                        setCodSis={setCodSis}
                        codEqp={codEqp}
                        setCodEqp={setCodEqp}
                        listSistemas={listSistemas}
                        listaEquipamento={listaEquipamento}
                        tipos={tipos}
                        nomeUsuario={nomeUsuario}
                        emailAdicional={emailAdicional}
                        setEmailAdicional={setEmailAdicional}
                        nomeAnexo={nomeAnexo}
                        onAnexoChange={onAnexoChange}
                        onSubmit={onSubmit}
                        salvando={salvando}
                        mensagem={mensagem}
                        sugestaoIA={sugestaoIA}
                        sugestaoIALoading={sugestaoIALoading}
                        sugestaoIAMensagem={sugestaoIAMensagem}
                        chamadosRelacionados={chamadosRelacionados}
                        onBuscarSugestaoIA={onBuscarSugestaoIA}
                    />
                    </div>
                </div>
            </main>
        </div>
    );
}

export default ChamadoCreatePage;
